import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import {Box, Drawer, IconButton, Typography} from '@mui/material';
import {useIntl} from 'react-intl';
import {SidebarCoveragePanel} from './SidebarCoveragePanel';

function MobileCoverageSheet({open, onClose, onUpdateRiders, ...coverageProps}) {
  const intl = useIntl();
  const handleUpdateRiders = () => {
    onUpdateRiders();
    onClose();
  };

  return (
    <Drawer
      anchor='bottom'
      open={open}
      onClose={onClose}
      ModalProps={{keepMounted: true}}
      PaperProps={{
        role: 'dialog',
        'aria-modal': true,
        'aria-labelledby': 'mobile-coverage-sheet-title',
        sx: theme => ({
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          maxWidth: 520,
          maxHeight: '88dvh',
          marginInline: 'auto',
          overflow: 'hidden',
          borderRadius: '22px 22px 0 0',
          backgroundColor: theme.palette.background.default,
          boxShadow: theme.shadows[16],
        }),
      }}
    >
      <Box
        dir='rtl'
        sx={theme => ({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1.5,
          padding: '12px 16px 10px',
          flex: 'none',
          borderBottom: `1px solid ${theme.palette.divider}`,
        })}
      >
        <Typography
          id='mobile-coverage-sheet-title'
          component='h2'
          sx={theme => ({
            margin: 0,
            color: theme.palette.text.primary,
            fontSize: theme.typography.pxToRem(18),
            fontWeight: theme.typography.fontWeightBold,
          })}
        >
          {intl.formatMessage({id: 'offers.coverageSheet.title'})}
        </Typography>
        <IconButton
          onClick={onClose}
          aria-label={intl.formatMessage({id: 'offers.coverageSheet.close'})}
          sx={theme => ({
            width: 36,
            height: 36,
            flex: 'none',
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            '&:hover': {backgroundColor: theme.palette.action.hover},
          })}
        >
          <CloseIcon fontSize='small'/>
        </IconButton>
      </Box>
      <Box
        dir='rtl'
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          padding: '0 14px calc(16px + env(safe-area-inset-bottom))',
        }}
      >
        <SidebarCoveragePanel {...coverageProps} onUpdateRiders={handleUpdateRiders}/>
      </Box>
    </Drawer>
  );
}

MobileCoverageSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  formikValues: PropTypes.object.isRequired,
  formikSetField: PropTypes.func.isRequired,
  formikErrors: PropTypes.object.isRequired,
  validateForm: PropTypes.func.isRequired,
  onUpdateRiders: PropTypes.func.isRequired,
};

export {MobileCoverageSheet};